import { FileWithShare } from "@/lib/supabase/supabaseTypes";

export const getFileTooltip = (file: FileWithShare) => {
	const createdAt = file.created_at
		? `Erstellt am: ${new Date(file.created_at).toLocaleDateString("de-ch")} ${
				file.created_at
					? `um ${new Date(file.created_at).toLocaleTimeString("de-ch")}`
					: ""
			}`
		: "";

	// Check if this is a canceled invoice
	const isCanceledInvoice = file.invoice_canceled_at;
	const canceledInfo = isCanceledInvoice
		? `\nStorniert am: ${new Date(file.invoice_canceled_at ?? "").toLocaleDateString("de-ch")} um ${new Date(file.invoice_canceled_at ?? "").toLocaleTimeString("de-ch")}`
		: "";

	if (createdAt) {
		return createdAt + canceledInfo;
	} else {
		return (file?.file_name ?? "Datei") + canceledInfo;
	}
};
